import { render, staticRenderFns } from "./MetronomeConfig.vue?vue&type=template&id=5009a206"
import script from "./MetronomeConfig.vue?vue&type=script&lang=ts"
export * from "./MetronomeConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports